import { call, put, takeLatest } from 'redux-saga/effects';

import { getFeedbackQuestions } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getFeedbackQuestions);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* feedbackQuestionSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
